import {
  GetStockLevelsInput,
  GetStockLocationsInput,
  PaginationInput,
  PurchaseOrderFilterInput,
} from '@/gql/graphql';

const stockLocationKeys = {
  all: ['stockLocations'] as const,
  list: (input: GetStockLocationsInput, pagination: PaginationInput) =>
    [...stockLocationKeys.all, 'list', input, pagination] as const,
  detail: (id: string) => [...stockLocationKeys.all, 'detail', id] as const,
  stockLevels: (
    id: string,
    input: GetStockLevelsInput,
    pagination: PaginationInput
  ) =>
    [
      ...stockLocationKeys.detail(id),
      'stockLevels',
      input,
      pagination,
    ] as const,
  purchaseOrders: (
    id: string,
    input: PurchaseOrderFilterInput | undefined,
    pagination: PaginationInput
  ) =>
    [
      ...stockLocationKeys.detail(id),
      'purchaseOrders',
      input,
      pagination,
    ] as const,
};

export default stockLocationKeys;
